module.exports = __webpack_public_path__ + "img/mothers_day_promotion.1e451721.jpg";